import React from 'react';
import Field from '../Field';
import TextArea from '../TextArea';

export default props => (
  <Field {...props}>
    <TextArea />
  </Field>
);
